import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import heic2any from "heic2any";
import * as api from '../../shared/api/apihandler';

@Component({
  selector: 'app-img-heic',
  templateUrl: './img-heic.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ImgHeicComponent implements OnInit, OnChanges {

  @Input() fileId: string;
  @Input() style: string;
  @Input() class: string;
  @Input() textColor: string = 'black';
  url;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  ngOnChanges(c: SimpleChanges) {
    if (!!c && !!c.fileId && !!c.fileId.currentValue && c.fileId.currentValue != c.fileId.previousValue) {
      this.url = null;
      fetch(api.jubloApi + 'api/shared/attachments/' + c.fileId.currentValue)
        .then((res) => res.blob())
        .then((blob) => this.gotFile(blob))
        .catch((e) => {
          console.log('Error',e);
        });
    }
  }

  async gotFile(blob: Blob) {
    let a = await heic2any({
      blob: blob,
      toType: "image/jpeg",
      quality: 0.2 });
    this.url = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(a as Blob))
  }
}
